import { useMemo } from 'react';

import { useKycData } from '../../../resources/hooks/useKycData';
import { buildAccountUsageOneInitialValues } from '../../accountUsageOne/resources/constants';
import { buildAccountUsageTwoInitialValues } from '../../accountUsageTwo/resources/constants';
import { buildAdditionalDocumentsInitialValues } from '../../additionalDocuments/resources/constants';
import { buildCompanyAddressesInitialValues } from '../../companyAddresses/resources/constants';
import { buildCompanySectorInitialValues } from '../../companySector/resources/constants';

export const useWizardFormInitialValues = () => {
    const { data, isLoading } = useKycData();
    const values = data?.data;

    const normalizedValues = useMemo(() => {
        return {
            ...values,
            accountUsage: {
                ...values?.accountUsage,
                ...buildAccountUsageOneInitialValues(values?.accountUsage),
                ...buildAccountUsageTwoInitialValues(values?.accountUsage),
            },
            additionalDocuments: buildAdditionalDocumentsInitialValues(values?.additionalDocuments),
            businessInformation: {
                ...values?.businessInformation,
                ...buildCompanyAddressesInitialValues(values?.businessInformation),
                ...buildCompanySectorInitialValues(values?.businessInformation),
                incorporationDate: values?.businessInformation?.incorporationDate
                    ? new Date(values.businessInformation.incorporationDate)
                    : undefined,
            },
        };
    }, [values]);

    return { values: normalizedValues, disabled: isLoading };
};
